<template>
  <div>
    <div class="flexc-cen-x fixed" >
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{WZYGName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
        <el-option
          v-for="item in DianList"
          :key="item.ID"
          :label="item.StoresName"
          :value="item.ID">
        </el-option>
      </el-select>
    </div>

    <el-container style="padding-top:15px">
<!-- 8c4ce2 -->
        <el-aside width="210px">
          <!-- 搜索筛选 -->
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-button size="medium" style="width:95%;" v-if="q1 == true"   type="primary" icon="el-icon-plus" @click="handlePassword()">添加{{WZYGName}}部门</el-button>
            </el-form>
            <div class="title flexc-cen-x cursor" @click="toAll()"> 
                <div style="margin-left:10px">所有部门<i class="el-icon-refresh-left"  style="margin-left:110px;font-size:18px"></i> </div>
            </div>
            <div style="height:63vh;overflow:auto;">
              <div class="css" v-for="(item,index) in typeList" style="width:95%;margin-top:20px;margin-bottom:2px" >
                <div v-if="item.ID == active" class="flex-xy cursor shadow" id="shadw" style="width:96%;margin-left:2%;border-radius:5px;border:1px solid #409EFF">
                    <div style="width:95%;padding-top:10px;padding-bottom:10px">
                        <div class="flex-spc-x">
                            <div class="flexc-cen-x">
                                <i class="el-icon-s-unfold"></i>
                                <div style="font-size:10px;margin-left:7px">{{item.StaffName}}</div>
                            </div>
                        </div>
                        <div class="flex-spc-x" style="margin-top:10px">
                            <div class="xiang">{{item.allStaffcount}}位</div>
                            <div class="flexc-cen-x">
                                <i class="el-icon-edit" style="color:#808080" v-if="q2 == true" @click="handlePassword(item)"></i>
                                <!-- <i class="el-icon-document-copy" style="color:#808080;margin-left:10px"></i> -->
                                <i class="el-icon-delete" style="color:#808080;margin-left:10px" v-if="q3 == true" @click="toDel(item)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item.ID != active" class="flex-xy cursor shadow" id="shadw" style="width:96%;margin-left:2%;border-radius:5px" >
                    <div style="width:95%;padding-bottom:10px">
                        <div class="flex-spc-x" style="padding-top:10px;" @click="toChoose(item)"> 
                            <div class="flexc-cen-x">
                                <i class="el-icon-s-unfold"></i>
                                <div style="font-size:10px;margin-left:7px">{{item.StaffName}}</div>
                            </div>
                        </div>
                        <div class="flex-spc-x" style="">
                          <div class="flexc-cen-x" style="width:250px;padding-top:10px" @click="toChoose(item)">
                             <div class="xiang" >{{item.allStaffcount}}位</div>
                          </div>
                          <div class="flexc-cen-x" style="padding-top:10px">
                                <i class="el-icon-edit" style="color:#808080" v-if="q2 == true" @click="handlePassword(item)"></i>
                                <!-- <i class="el-icon-document-copy" style="color:#808080;margin-left:10px"></i> -->
                                <i class="el-icon-delete" style="color:#808080;margin-left:10px"  v-if="q3 == true" @click="toDel(item)"></i>
                          </div>
                        </div>
                    </div>
 
                </div>
              </div>
            </div>
        </el-aside>
         <el-main>
            <div class="flex-spc-x" style="width:100%;">
                 <div class="padding-left:5px" style="font-size:15px"></div>
                 <div>
                   <el-button size="mini" type="primary" icon="el-icon-plus" v-if="q4 == true" @click="handleEdit()">添加{{WZYGName}}</el-button>
                    <el-button size="mini" type="success" v-if="tableData.length > 1 && q8 == true" @click="toSort()">排序</el-button>
                 </div>
            </div>
            <div style="margin-top:20px;width:100%;">
              <el-table  :data="tableData" highlight-current-row v-loading="loading" size="small"    element-loading-text="拼命加载中" style="width: 100%;margin-left:-10px">
                    <el-table-column  prop="Name" label="姓名">
                      <template slot-scope="scope">
                        <div class="flexc-cen-x">
                          <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                          <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                          <div style="margin-left:5px">{{scope.row.Name}}</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column  prop="Phone" label="联系电话"  align="center">
                    </el-table-column>
                    <el-table-column  prop="Phone" label="性别"  align="center">
                       <template slot-scope="scope">
                          <span v-if="scope.row.Sex == 1">男</span>
                          <span v-if="scope.row.Sex == 2">女</span>
                      </template>
                    </el-table-column>
                    <el-table-column  prop="StaffTypeName" label="所属部门"  align="center">
                    </el-table-column>
                    <!-- <el-table-column  prop="TcStaffTypeID" label="所属门店" >
                    </el-table-column> -->

                    <el-table-column  prop="TitleName" label="头衔" align="center">
                    </el-table-column>
                    <el-table-column  prop="LoginID" label="是否为操作员"  align="center">
                       <template slot-scope="scope">
                          <span v-if="scope.row.LoginID>0">是</span>
                          <span v-if="scope.row.LoginID == 0">否</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="addTime" label="创建时间" >
                    </el-table-column>
                    <el-table-column prop="ShopName" label="商户名称" >
                    </el-table-column> -->
                    <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
                    </el-table-column> -->
                  <el-table-column align="center" label="操作" width="320" >
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.row)" v-if="q5 == true">编辑</el-button>
                      <el-button v-if="scope.row.Isdisable == 0 && q7 == true" type="warning" plain size="mini" @click="handlejin(scope.row)">禁用</el-button>
                      <el-button v-if="scope.row.Isdisable == 1 && q7 == true" type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button>
                      <el-button size="mini" type="info" v-if="q6 == true" @click="deleteUser(scope.row)">删除</el-button>
                          <el-popover placement="bottom" trigger="hover">
                            <div class="">
                              <div class="flexc-cen-x cursor" v-if="iscdyy==0" style="height: 30px" @click="toLook(scope.row)">
                                <i class="el-icon-chat-line-round"></i>
                                <div style="margin-left: 10px; color: #65a8ff">查看评价</div>
                              </div>
                              <div class="flexc-cen-x cursor" style="height: 30px"  v-if=" scope.row.LoginID >0 "  @click="chongzhi(scope.row)">
                                <i class="el-icon-refresh-right"></i>
                                <div style="margin-left: 10px; color: #65a8ff">重置密码</div>
                              </div>
                              <div class="flexc-cen-x cursor" v-if="q10== true && scope.row.LoginID == 0" style="height: 30px"   @click="shezhi(scope.row)">
                                <i class="el-icon-s-custom"></i>
                                <div style="margin-left: 10px; color: #65a8ff">设置为操作员</div>
                              </div>
                              <div class="flexc-cen-x cursor" style="height: 30px" v-if="q9 == true && iscdyy==0" @click="editTi(scope.row)">
                                <i class="el-icon-edit"></i>
                                <div style="margin-left: 10px; color: #65a8ff">编辑提成</div>
                              </div>
                              <div class="flexc-cen-x cursor" style="height: 30px" v-if="q9 == true && iscdyy==1" @click="editTi1(scope.row)">
                                <i class="el-icon-edit"></i>
                                <div style="margin-left: 10px; color: #65a8ff">编辑提成</div>
                              </div>
                              <div class="flexc-cen-x cursor" style="height: 30px" v-if="iszjyy==1" @click="editQJ(scope.row)">
                                <i class="el-icon-edit"></i>
                                <div style="margin-left: 10px; color: #65a8ff">请假设置</div>
                              </div>
                              <div class="flexc-cen-x cursor" style="height: 30px" v-if="q5 == true && isvideo==1" @click="editZP(scope.row)">
                                <i class="el-icon-edit"></i>
                                <div style="margin-left: 10px; color: #65a8ff">作品设置</div>
                              </div>
                              <div class="flexc-cen-x cursor" style="height: 30px" v-if="q5 == true" @click="editerweim(scope.row)">
                                <i class="el-icon-picture-outline"></i>
                                <div style="margin-left: 10px; color: #65a8ff">绑定二维码</div>
                              </div>
                            </div>
                            <el-button
                              size="mini"     
                              slot="reference"
                            >更多操作</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
              </el-table>
              <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </div>
         </el-main>
    </el-container>

    <!--列表-->
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    
  <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="margin-bottom:120px">
        <el-form-item label="姓名:" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="Phone" >
          <el-input size="small" v-model="editForm.Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密码:" prop="Pwd" v-if="title =='添加员工' " >
          <el-input size="small" v-model="editForm.Pwd" auto-complete="off" placeholder="请输入密码" style="width: 215px"></el-input>
        </el-form-item> -->
          <el-form-item label="头像:" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="height: 100px;width:100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn cursor"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                   
                
                   
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item>
           <el-form-item label="所属部门:" prop="StaffTypeID">
            <el-select v-model="editForm.StaffTypeID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList"
                  :key="item.ID"
                  :label="item.StaffName"
                  :value="item.ID">
                </el-option>
              </el-select>
           </el-form-item>
         <el-form-item label="性别:" prop="Sex">
           <el-radio-group v-model="editForm.Sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>
           </el-radio-group>

          </el-form-item>
         <el-form-item  label="是否排班:"  v-if="iscdyy==0" prop="ispk">
           <el-radio-group v-model="editForm.ispk">
             <el-radio :label="0">否</el-radio>
             <el-radio :label="1">是</el-radio>
           </el-radio-group>

          </el-form-item>
          <el-form-item label="是否显示:" prop="iszs">
           <el-radio-group v-model="editForm.iszs">
             <el-radio :label="0">否</el-radio>
             <el-radio :label="1">是</el-radio>
           </el-radio-group>

          </el-form-item>
          <el-form-item label="邮箱:" prop="Email">
          <el-input size="small" v-model="editForm.Email" auto-complete="off" placeholder="请输入邮箱"  style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="地址:" prop="Address">
          <el-input size="small" placeholder="请输入地址" v-model="editForm.Address"  auto-complete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="头衔:" prop="Title">
           <el-select v-model="editForm.Title" placeholder="请选择" size="small">
                <el-option
                  v-for="item in unitList"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.ID">
                </el-option>
           </el-select>
            <el-button type="text" size="mini" style="margin-left:10px;font-size:16px" @click="toshow">设置</el-button>
        </el-form-item>
        <el-form-item label="个人介绍:" prop="Introduce">
            <el-input type="textarea" :rows="2" placeholder="请输入个人介绍" v-model="editForm.Introduce" style="width: 80%"></el-input>
        </el-form-item>


      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div> -->
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
     <el-drawer :wrapperClosable= false title="排序" :visible.sync="sortSure" :direction="direction" size="30%">
      <div style="height:70vh;overflow:auto">
       <div  v-for="(item,index) in tableSortData" class="heng flex-xy" style="width:85%">
          <div class="flex-spc-x" style="width:99%">
            <div class="flexc-cen-x">
              <img :src="item.HeadUrl" v-if="item.HeadUrl !='' " style="width:40px;height:40px;border-radius:100%" alt="">
              <img v-if="item.HeadUrl =='' " src="../../assets/img/head.png" style="width:40px;height:40px;border-radius:100%" alt="">
                    <div style="font-size:15px;margin-left:5px">{{item.Name}}</div>
            </div>
            <div>
              <el-button v-show="index !=0" size="mini" icon="el-icon-top"  type="primary" plain @click="toTop(item)">升序</el-button>
              <el-button  v-show="index != tableData.length - 1 " size="mini" icon="el-icon-bottom" type="success" plain @click="toDown(item)">降序</el-button>
            </div>
          </div>
        </div> 
      </div>

      <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="closeDialog"
            >确定</el-button
          >
      </div>
     </el-drawer>
    <!-- </el-dialog> -->
  <el-dialog :title="title" :visible.sync="passShow2" width="40%" @click="passShow2 = false">
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="部门" prop="StaffName">
          <el-input size="small" placeholder="请输入部门" v-model="StaffName"  auto-complete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="passShow2 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="subStaffName()">保存</el-button>
      </div>
  </el-dialog>
  <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
  </el-dialog>
            <!--查看大封面-->
  <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
  </el-dialog>
  <el-dialog title="头衔列表" :visible.sync="showUnit" :direction="direction" width="500px" > 
      <div class="flex-spc-x" style="width:100%;margin-top:-20px;margin-bottom:10px">
        <div>   
        </div>
        <div>
          <el-button size="mini" type="primary" @click="addUnit()">+ 添加头衔</el-button>
        </div>
      </div>
     <el-table
     
          :data="unitList"
          tooltip-effect="dark"
          max-height="300px"
          size="small"
          style="width:450px"
    >
        <el-table-column
        label="头衔"
          prop="Title"
         >
          <!-- <template slot-scope="scope">
            <div class="flexc-cen-x">
        
              <el-button type="text" size="mini" icon="el-icon-delete" class="Danger" v-if="scope.row.isAdmin != 1"  @click="toshan(scope.row)">删除</el-button>
            </div>
            </template> -->
        </el-table-column>
       <el-table-column
          label="操作"
          fixed="right"
          width="120px"
          align="center"
         >
          <template slot-scope="scope">
            <div class="">
              <el-button type="text" size="mini" icon="el-icon-edit"  @click="toeditTtile(scope.row)">修改</el-button>
              <el-button type="text" size="mini" icon="el-icon-delete" class="Danger"   @click="toshan(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>

  
    </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="showUnit = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="showUnit = false">确定</el-button>
        </div>

  </el-dialog>
  <el-dialog :title="title1" :visible.sync="passShow" width="450px" @click="passShow = false">
      <el-form label-width="120px" :model="editForm">
        <el-form-item label="头衔" prop="deptNo">
          <el-input size="small" placeholder="请输入头衔" v-model="Pwd" auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="passShow = false">取消</el-button>
        <el-button size="small" type="primary"   @click="topass()">保存</el-button>
      </div>
  </el-dialog>
  <el-dialog title="编辑提成" :visible.sync="showTi" width="700px" :close-on-click-modal="false">
    <div class="flex-spc-x" style="margin-top:-30px">
      <div></div>
     <el-button size="mini" type="primary" :loading="loading" @click="choosePro()">选择{{WZXMName}}</el-button>
    </div>
    <div :key="timer" class="timer" style="margin-top:20px">
      <div class="css flex-spc-x" v-for="(items,index) in ListProjectStaffAmount" v-if="items.state !=3" style="width:100%;margin-top:5px;margin-bottom:2px" >
          <div class="flex-xy " id="shadw" style="padding-left:2%;border-radius:5px">
              <div style="padding-top:10px;padding-bottom:10px">
                  <div class="flex-spc-x"> 
                      <div class="flexc-cen-x">
                          <i class="el-icon-s-unfold" style="font-size:15px"></i>
                          <div style="font-size:15px;padding-left:7px">{{items.ProjectName}}</div>
                      </div>

                   </div>
              </div>
            </div>

                    <el-radio-group v-model="items.tctype" @change="changeitems(items)">
                      <el-radio :label="1"  v-if="ct !=2">按次数</el-radio>
                      <el-radio :label="2">按人数</el-radio>
                    </el-radio-group>
    
                  <div>
                      <div  class="choosePerson flex-spc-x" >
                        <div class="flexc-cen-x">
                          <el-input size="mini" v-model="items.tcAmount" style="width:120px" @input="forceUpdate" @change="changeitems(items)" placeholder="请输入内容"></el-input>  元
                        </div>
                        <div style="padding-left:40px">    
                          <el-button type="text"  icon="el-icon-delete" @click="deletePrice(index,items)"></el-button>
                        </div>
                    </div>
                  </div>
  
      </div> 
        <div class="flex-xy" style="margin-top:20px" v-if=" ListProjectStaffAmount.length == 0">
            <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
            <div style="margin-top:20px;color:#808080">暂无数据</div>
        </div>
    </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showTi = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="Sure1()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑提成" :visible.sync="showTi1" width="700px" :close-on-click-modal="false">
    <div class="flex-spc-x" style="margin-top:-30px">
      <div></div>
     <el-button size="mini" type="primary" :loading="loading" @click="choosePro1()">选择{{WZCDName}}</el-button>
    </div>
    <div :key="timer" class="timer" style="margin-top:20px">
      <div class="css flex-spc-x" v-for="(items,index) in ListSiteStaffAmount" v-if="items.state !=3" style="width:100%;margin-top:5px;margin-bottom:2px" >
          <div class="flex-xy " id="shadw" style="padding-left:2%;border-radius:5px">
              <div style="padding-top:10px;padding-bottom:10px">
                  <div class="flex-spc-x"> 
                      <div class="flexc-cen-x">
                          <i class="el-icon-s-unfold" style="font-size:15px"></i>
                          <div style="font-size:15px;padding-left:7px">{{items.SiteName}}</div>
                      </div>

                   </div>
              </div>
            </div>

                    <el-radio-group v-model="items.tctype" @change="changeitems1(items)">
                      <el-radio :label="1"  v-if="ct !=2">按次数</el-radio>
                      <el-radio :label="2">按人数</el-radio>
                    </el-radio-group>
    
                  <div>
                      <div  class="choosePerson flex-spc-x" >
                        <div class="flexc-cen-x">
                          <el-input size="mini" v-model="items.tcAmount" style="width:120px" @input="forceUpdate" @change="changeitems1(items)" placeholder="请输入内容"></el-input>  元
                        </div>
                        <div style="padding-left:40px">    
                          <el-button type="text"  icon="el-icon-delete" @click="deletePrice1(index,items)"></el-button>
                        </div>
                    </div>
                  </div>
  
      </div> 
        <div class="flex-xy" style="margin-top:20px" v-if=" ListProjectStaffAmount.length == 0">
            <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
            <div style="margin-top:20px;color:#808080">暂无数据</div>
        </div>
    </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showTi1 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="Sure2()">确定</el-button>
      </div>
    </el-dialog>

    
  <el-drawer :wrapperClosable= false :title="'选择'+ WZXMName " :visible.sync="proShow" :direction="direction" size="30%">
      <div style="padding-bottom:100px">
        <el-tree
              :key="timer"
              :data="proList"
              :props="props"
              show-checkbox
              ref="tree"
              default-expand-all
              node-key="ID"
        >
        </el-tree>
      </div>

          <!-- @check ="chooseQuan" -->
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="proShow = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
         
            @click="baocun"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false :title="'选择'+ WZCDName " :visible.sync="proShow1" :direction="direction" size="30%">
      <div style="padding-bottom:100px">
        <el-tree
              :key="timer"
              :data="proList1"
              :props="props1"
              show-checkbox
              ref="tree"
              default-expand-all
              node-key="ID"
        >
        </el-tree>
      </div>

          <!-- @check ="chooseQuan" -->
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="proShow1 = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="baocun1"
            >保存</el-button
          >
        </div>
    </el-drawer>
    
  <el-dialog title="设置为操作员" :visible.sync="passwordShow" width="40%" >
      <el-form label-width="120px" >

        <el-form-item label="新密码" prop="password">
          <el-input size="small" placeholder="请输入密码" v-model="password" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password1">
          <el-input size="small" placeholder="请输入密码" v-model="password1" show-password auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary"  @click="topassWord()">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
            class="normalDrawer"
            title="请假设置"
            direction="ltr"
            size="50%"
            :visible.sync="showqjszRightDrawer"
            :wrapperClosable="false"
            >
            <div class="drawerForm drawerMemberWrap">
             <div class="drawerTable">
                <div class="flexS right">
                    <el-button icon="el-icon-plus"  type="primary" @click="addQjtimeClick">添加请假时间</el-button>
                   </div>
                   <p class="tableTitle">请假时间列表</p>
                    
                         <el-table :data="listStaffQjTime"   :row-key="row => row.index" :header-cell-style="{'background-color':'#f8f8f8'}">
                    
                            
                           
                              <el-table-column label="请假时间" prop="Qjtime"  ></el-table-column>
                                <el-table-column label="操作" align="center"  width="180">
                                <template slot-scope="scope" class="flexB">
                                     <el-button type="text" @click="deleteQjtimeClick(scope.row)"  >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
            </div>
        </el-drawer>

        <el-dialog
      title="提示"
      :visible.sync="dialogqjszVisible"
      width="360px"
      center
      >
       <span slot="title">
        <p>
          添加请假时间
        </p>
      </span>
      <div class="flexC">
          <span style="margin-top:7px;">开始时间: </span> &nbsp;
          <el-date-picker  v-model="Qjtime"
                            type="date"
                            placeholder="请假开始时间"
                             value-format="yyyy/MM/dd">
                        </el-date-picker> 
          
      </div>
      <div class="flexC">
          <span style="margin-top:17px;">结束时间: </span> &nbsp;
          <el-date-picker style="margin-top:10px;" v-model="eQjtime"
                            type="date"
                            placeholder="请假结束时间"
                             value-format="yyyy/MM/dd">
                        </el-date-picker> 
          
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogqjszVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveqjtime">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="作品列表" :visible.sync="StaffOpus" :direction="direction" width="500px" > 
      <div class="flex-spc-x" style="width:100%;margin-top:-20px;margin-bottom:10px">
        <div>   
        </div>
        <div>
          <el-button size="mini" type="primary" @click="addStaffOpus()">+ 添加作品</el-button>
        </div>
      </div>
     <el-table
     
          :data="ListStaffOpus"
          tooltip-effect="dark"
          max-height="300px"
          size="small"
          style="width:450px"
    >
        <el-table-column
        label="作品名称"
          prop="OpusName"
         >
           
        </el-table-column>
        <el-table-column
        label="作品展示图片"
          prop="ImgOpusUrl"
         >
         <template slot-scope="scope">
                        <div class="flexc-cen-x">
                          <img :src="scope.row.ImgOpusUrl" v-if="scope.row.ImgOpusUrl !='' " style="width:60px;height:40px;" alt="">
                          <img v-if="scope.row.ImgOpusUrl =='' " src="../../assets/img/head.png" style="width:60px;height:40px;" alt="">
                         </div>
           </template>
        </el-table-column>
       <el-table-column
          label="操作"
          fixed="right"
          width="120px"
          align="center"
         >
          <template slot-scope="scope">
            <div class="">
              <el-button type="text" size="mini" icon="el-icon-edit"  @click="toeditStaffOpus(scope.row)">修改</el-button>
              <el-button type="text" size="mini" icon="el-icon-delete" class="Danger"   @click="toStaffOpusshan(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>

  
    </el-table>

    

  </el-dialog>
  <el-dialog title="添加作品" :visible.sync="StaffOpusAdd" width="450px" @click="StaffOpusAdd = false">
      <el-form label-width="120px" :model="StaffOpusInfo">
        <el-form-item label="作品名称" prop="deptNo">
          <el-input size="small" placeholder="作品名称" v-model="StaffOpusInfo.OpusName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="作品展示图:" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="StaffOpusInfo.ImgOpusUrl !== ''">
                    <img
                      :src="StaffOpusInfo.ImgOpusUrl"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('ImgOpusUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn cursor"
                    style="width: 121px; height: 81px"
                    @click="uploadPicture('ImgOpusUrl')"
                  >
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                   
                
                   
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="StaffOpusInfo.ImgOpusUrl"
                  placeholder="请添加"
                />
          </el-form-item>
          <el-form-item label="作品路径" prop="deptNo">
          <el-input size="small" placeholder="作品路径" v-model="StaffOpusInfo.OpusUrl" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="StaffOpusAdd = false">取消</el-button>
        <el-button size="small" type="primary"   @click="toStaffOpusAdd()">保存</el-button>
      </div>
  </el-dialog>
  <el-dialog title="编辑作品" :visible.sync="StaffOpusEdit" width="450px" @click="StaffOpusEdit = false">
      <el-form label-width="120px" :model="StaffOpusInfo">
        <el-form-item label="作品名称" prop="deptNo">
          <el-input size="small" placeholder="作品名称" v-model="StaffOpusInfo.OpusName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="作品展示图:" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="StaffOpusInfo.ImgOpusUrl !== ''">
                    <img
                      :src="StaffOpusInfo.ImgOpusUrl"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('ImgOpusUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn cursor"
                    style="width: 121px; height: 81px"
                    @click="uploadPicture('ImgOpusUrl')"
                  >
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                   
                
                   
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="StaffOpusInfo.ImgOpusUrl"
                  placeholder="请添加"
                />
          </el-form-item>
          <el-form-item label="作品路径" prop="deptNo">
          <el-input size="small" placeholder="作品路径" v-model="StaffOpusInfo.OpusUrl" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="StaffOpusEdit = false">取消</el-button>
        <el-button size="small" type="primary"   @click="toStaffOpusEdit()">保存</el-button>
      </div>
  </el-dialog>
  <el-dialog
            title="提示"
            :visible.sync="dialogdelVisible2"
            width="360px"
            center
        >
       <span slot="title">
        <p>绑定二维码</p>
      </span>
            <div class="flexC">
                 <vue-qr :margin='0' :text="TerPaths" :size='200'></vue-qr>
            </div>

        </el-dialog>
  </div>
</template>

<script>
    import VueQr from 'vue-qr'
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
      props: {
          children: 'sublist',
          label: 'ProjectName'
      },
      props1: {
          children: 'sublist',
          label: 'SiteTypeName'
      },
      listTi:[],
      SelectStoresID:localStorage.getItem("StoresID"),
      WZXMName:localStorage.getItem("WZXMName"),
      iszjyy:localStorage.getItem("iszjyy"),
      iscdyy:localStorage.getItem("iscdyy"),
      isvideo:localStorage.getItem("isvideo"),
      listStaffQjTime:[],
      StaffQjTimeID:'',
      StaffID:'',
      Qjtime:'',
      eQjtime:'',
      dialogdelVisible2:false,
      dialogqjszVisible:false,
      sortSure:false,
      showqjszRightDrawer:false,
      active:'',
      TerPaths:'',
      name:'全部',
      proShow:false,
      proShow1:false,
      imgVisible:false,
      typeList:[],
      unitList:[],
      StaffName:'',
       activeName: 'first',
      value:true,
       direction: "ltr",
      passShow:false,
      passShow1:false,
      timer:'',
      money:'',
      input:'',
           ct:'',
      cropperModel:false,

      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      Pwd:'',
      id:'',
      DianList:[],
      cropperName:'',
      title1:'',
       editForm: {
        StaffTypeID:'',
        Sex:1,
        HeadUrl:'',
        LoginName:"",
        Phone:"",
        Name:"",
        Pwd:"",
        money:"",
        ispk:'1',
        iszs:'1',
        ShopName:"",
        token: localStorage.getItem('token')
      },
      // rules表单验证

      rules: {
        // LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          // Pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          StaffTypeID:[{ required: true, message: '请选择部门', trigger: 'blur' }],
          // money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          // ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      proList:[],
      proList1:[],
      ListProjectStaffAmount:[],
      ListSiteStaffAmount:[],
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      passShow2:false,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

       Limits:[],
       tableSortData:[],
       ListStaffOpus:[],
       StaffOpus:false,
      showTi:false,
      showTi1:false,
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      q9:false,
      sh:false,
      WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      WZCDName:'',
      typeName:'',
      showUnit:false,
      StaffTitleID:'',
      items:'',
      passwordShow:false,
      password:'',
      password1:'',
      StaffOpusInfo:{
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:this.StaffID ,
          OpusName:'' ,
          ImgOpusUrl:'' ,
          OpusUrl:'' ,
      }, 
      StaffOpusEdit:false, 
      StaffOpusAdd:false,
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
     VueQr
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = '员工'
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.WZCDName = localStorage.getItem('WZCDName')

    this.getType()
    this.getList()
    this.getDianList()
    this.getRowType()
    this.getUnitList()
     if(localStorage.getItem('StoresType')== 1){
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
        
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
          this.q9 = true
          this.q10 = true
      }
    this.Limits = localStorage.getItem('Limits')
    this.Limits = this.Limits.split(',')
    this.Limits.forEach(items => {
          if(items == 52){
            this.q1 = true
          }
          if(items == 53){
            this.q2 = true
          }
          if(items == 54){
            this.q3 = true
          }
          if(items == 55){
            this.q4 = true
          }
          if(items == 56){
            this.q5 = true
          }
           if(items == 57){
            this.q6 = true
          }
           if(items == 58){
            this.q7 = true
          }
           if(items == 59){
            this.q8 = true
          }
          if(items ==  551){
            this.q9 = true
          }
          if(items ==  552){
            this.q10 = true
          }
          
   })
      // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    toLook(row){
    this.$router.push({
        path: `/personnel/appraise/${row.ID}`,
      });
    },editerweim(row){
      console.log("editerweim",row.ermPath);
      this.TerPaths = row.ermPath
      this.dialogdelVisible2 =true;
    },
    topassWord(){
      var that = this
      if(this.password == this.password1 && this.password !='' && this.password1 !=''){
          var list = {
            Phone:this.items.Phone,
            Name:this.items.Name,
            Pwd:this.password,
            HeadUrl:this.items.HeadUrl,
            StaffID:this.items.ID,
            Email:'',
            Note:'',
            Role:'',
            StaffIDs:'',
            token:localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            SelectStoresID : this.SelectStoresID
          }
        this.ajax('addLogin.aspx',JSON.stringify(list),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.passwordShow = false
                        that.getList()
                     }

                })
      } else{
          this.$message({
                   message: "请输入相对应的密码",
            });
      }
    },
    shezhi(items){
      this.password = ''
      this.password1 = ''
      this.passwordShow = true
      this.items = items
    },
     getRowType(){
          this.ct = 1
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                if(res.data.length == 1){
                  if(res.data[0].RowType == 2){
                        that.ct = 2
                  }
                }
                that.RowTypeList = res.data
    
          } 
       })
    },
    changeitems(items){
      if(items.ID !=0){
        items.state = 2
      }
      
  },
  changeitems1(items){
      if(items.ID !=0){
        items.state = 2
      }
      
  },
  deletePrice(index,items){
    console.log(index)
    console.log(items)
    items.state = 3
    // this.ListProjectStaffAmount.splice(index,1)
    // items.list.splice(index,1)
    this.timer = new Date().getTime()
  },
  deletePrice1(index,items){
    console.log(index)
    console.log(items)
    items.state = 3
    // this.ListProjectStaffAmount.splice(index,1)
    // items.list.splice(index,1)
    this.timer = new Date().getTime()
  },
  
  forceUpdate () { 
    this.$forceUpdate() 
  },baocun1(){
        let selectNodes = this.$refs.tree.getCheckedNodes();
        console.log('selectNodes',selectNodes)
        console.log('ListSiteStaffAmount',this.ListSiteStaffAmount)

            let NodeIDs = [];
            selectNodes.forEach(item =>{
              if(item.SiteTypeID>0){

       
                  var list = {} 
                  var cd = false
                 this.ListSiteStaffAmount.forEach((items,index1) =>{
                      if(items.SiteID == item.ID && items.state != 3){
                        cd = true;
                        list = items;
                          
                        } 
                        var index1  = index1     
                    })
                    if(cd == false) {
                      list = {
                        ID:0,
                        SiteID:item.ID,
                        SiteName:item.SiteTypeName,
                        StaffID:this.editForm.ID,
                        state:1,
                        tctype:2,
                        tcAmount:0,
                      }
                
                  } 

                  NodeIDs.push(list);
                }
                
            })

            console.log('ListSiteStaffAmount', this.ListSiteStaffAmount)
            console.log('NodeIDs',NodeIDs)
            for(var i = 0;i<this.ListSiteStaffAmount.length;i++){
                for(var j = 0;j<NodeIDs.length;j++){
                  if(this.ListSiteStaffAmount[i].SiteID == NodeIDs[j].SiteID){
                         break
                  }
                }
                if( j == NodeIDs.length ){

                  this.ListSiteStaffAmount[i].state = 3
                  NodeIDs.push(this.ListSiteStaffAmount[i])

                }
            }

            this.ListSiteStaffAmount = NodeIDs
            this.proShow1 = false

    },
    baocun(){
        let selectNodes = this.$refs.tree.getCheckedNodes();

            let NodeIDs = [];
            selectNodes.forEach(item =>{
              
                if(item.ProjectTypeName){

                } else { 
                  var list = {} 
                  var cd = false
                 this.ListProjectStaffAmount.forEach((items,index1) =>{
                      if(items.ProjectID == item.ID && items.state != 3){
                        cd = true;
                        list = items;
                          
                        } 
                        var index1  = index1     
                    })
                    if(cd == false) {
                      list = {
                        ID:0,
                        ProjectID:item.ID,
                        ProjectName:item.ProjectName,
                        StaffID:this.editForm.ID,
                        state:1,
                        tctype:2,
                        tcAmount:0,
                      }
                
                } 

                  NodeIDs.push(list);

                }
              
              
            })
            for(var i = 0;i<this.ListProjectStaffAmount.length;i++){
                for(var j = 0;j<NodeIDs.length;j++){
                  if(this.ListProjectStaffAmount[i].ProjectID == NodeIDs[j].ProjectID){
                         break
                  }
                }
                if( j == NodeIDs.length ){

                  this.ListProjectStaffAmount[i].state = 3
                  NodeIDs.push(this.ListProjectStaffAmount[i])

                }
            }

            this.ListProjectStaffAmount = NodeIDs
            this.proShow = false

    },
    getPro(){
      var list = []
       this.ListProjectStaffAmount.forEach(items => {
         list.push(items.ProjectID)
      });
      var data = { 

          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),

      }
      var that = this
      this.ajax('getListProjecttc.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                if(res.data.length == 0){
                  that.sh = true
                } else{
                  that.sh = false
                }
              that.proList = res.data
              that.proList.forEach(items => {
                items.ProjectName = items.ProjectTypeName
              }); 
  

              that.proShow = true
          } 
       })
 
        
         this.$nextTick(function () {
        this.$refs.tree.setCheckedKeys(list,true);
          
    })
        this.proShow = true
    this.timer = new Date().getTime()
    },
    choosePro(){
      this.getPro()
      // getListProjecttc.aspx
    },
    choosePro1(){
      this.getPro1()
      // getListProjecttc.aspx
    },    getPro1(){
      var list = []
       this.ListSiteStaffAmount.forEach(items => {
         list.push(items.SiteID)
      });
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          SiteTypeID:0
      }
      var that = this
      this.ajax('getListSitetc.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                if(res.data.length == 0){
                  that.sh = true
                } else{
                  that.sh = false
                }
              that.proList1 = res.data
              
  

              that.proShow1 = true
          } 
       })
 
     
        
         this.$nextTick(function () {
        this.$refs.tree.setCheckedKeys(list,true);
          
    })
        this.proShow1 = true
    this.timer = new Date().getTime()
    },
    addTi(){
   var list = []
      this.ListProjectStaffAmount.forEach(items => {
          if(items.state != 3){
            list.push(items)
          }
      });
     
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ListProjectStaffAmount:list
      }
      var that = this
      this.ajax('addProjectStaffAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "添加成功",duration:2000,
              });
              that.getList()
              that.showTi = false
                
          } 
       })

    },Sure2(){
      if(this.sh == true){
          this.addTi1()
      } else {
        this.editTI1()
      }
   
    },
    addTi1(){
   var list = []
      this.ListSiteStaffAmount.forEach(items => {
          if(items.state != 3){
            list.push(items)
          }
      });
     
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ListSiteStaffAmount:list
      }
      var that = this
      this.ajax('addSiteStaffAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "添加成功",duration:2000,
              });
              that.getPTlist1()
              that.showTi1 = false
                
          } 
       })

    },
    editTI1(){

     
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ListSiteStaffAmount:this.ListSiteStaffAmount
      }
      var that = this
      this.ajax('editSiteStaffAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "修改成功",duration:2000,
              });
             that.getPTlist1()
              that.showTi1 = false
                
          } 
       })

    },
    Sure1(){
      if(this.sh == true){
          this.addTi()
      } else {
        this.editTI()
      }
   
    },
    editTI(){

     
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ListProjectStaffAmount:this.ListProjectStaffAmount
      }
      var that = this
      this.ajax('editProjectStaffAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "修改成功",duration:2000,
              });
             that.getList()
              that.showTi = false
                
          } 
       })

    },getPTlist1(id){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:id
      }
      var that = this
      this.ajax('getListSiteStaffAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              res.data.forEach(items => {
                items.tctype = parseInt(items.tctype) 
          
              }); 
              that.ListSiteStaffAmount = res.data

              that.showTi1 = true
                
          } 
       })
    },
    getPTlist(id){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:id
      }
      var that = this
      this.ajax('getListProjectStaffAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              res.data.forEach(items => {
                items.tctype = parseInt(items.tctype) 
          
              }); 
              that.ListProjectStaffAmount = res.data

              that.showTi = true
                
          } 
       })
    },editTi1(items){
      this.getPTlist1(items.ID)
      this.editForm = items
 
    },
    editTi(items){
      this.getPTlist(items.ID)
      this.editForm = items
      this.showTi  = true

    },editQJ(items){
      this.StaffID = items.ID;
      this.getListStaffQjTime();
    },editZP(items){
      this.StaffID = items.ID;
      this.getListStaffOpus();
      
    },getListStaffOpus(){
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:999,
          StaffID:this.StaffID
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListStaffOpus.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.ListStaffOpus = res.data
                 that.StaffOpus=true;
                 loading.close();
          } 

      })
    },
    getListStaffQjTime(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:this.StaffID
      }
      var that = this
      this.ajax('getListStaffQjTime.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
        
              that.listStaffQjTime = res.data

              that.showqjszRightDrawer = true
                
          } 
       })
    },addQjtimeClick(){
                this.Qjtime='';
                this.eQjtime='';
               this.dialogqjszVisible=true;
            },saveqjtime(){
                this.addQjtime();
            },addQjtime(){
              var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:this.StaffID,
          Qjtime:this.Qjtime,
          eQjtime:this.eQjtime,
      }
        var that = this
       this.ajax('addStaffQjtime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                            type: "success",
                            message: "操作成功",
                            duration:2000,
              });
              that.dialogqjszVisible=false;

              that.getListStaffQjTime()

               
            }

      })
            },deleteQjtimeClick(val){
      this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
           this.delTeaQjTime(val.ID) 
          }).catch(() => {
                    
        });
    },delTeaQjTime(id){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffQjTimeID:id,
      }
        var that = this
       this.ajax('delStaffQjTime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.getListStaffQjTime()
              that.$message({
                            type: "success",
                            message: "刪除成功",
                            duration:2000,
              });
             
               
            }

      })

    },
    toshan(item){
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffTitleID:item.ID,
      }
        var that = this
       this.ajax('delStaffTitle.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.getUnitList()
              that.$message({
                            type: "success",
                            message: "刪除成功",duration:2000,
              });
             
               
            }

      })
        })
        .catch(() => {
          
        })
    },
    
    topass(){
      if(this.title1 == '添加头衔'){
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          Title:this.Pwd
      }
      var that = this
      this.ajax('addStaffTitle.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "添加成功",duration:2000,
              });
              that.getUnitList()
              that.passShow = false
                
          } 
       })
    
      } else {
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          Title:this.Pwd,
          StaffTitleID:this.StaffTitleID
      }
      var that = this
      this.ajax('editStaffTitle.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "修改成功",duration:2000,
              });
              that.getUnitList()
              that.passShow = false
              
          } 
       })
    
      }
     
    },addStaffOpus(){
      this.StaffOpusInfo={
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:this.StaffID ,
          OpusName:'' ,
          ImgOpusUrl:'' ,
          OpusUrl:'' ,

      }  
      this.StaffOpusAdd=true;
    },toStaffOpusAdd(){
      var data = this.StaffOpusInfo
      const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var that = this
        this.ajax('addStaffOpus.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
            that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.getListStaffOpus()
              that.StaffOpusAdd=false;

              loading.close();

            }

        })
    },toeditStaffOpus(row){
      this.StaffOpusInfo={
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffID:row.StaffID ,
          OpusName:row.OpusName ,
          ImgOpusUrl:row.ImgOpusUrl ,
          OpusUrl:row.OpusUrl ,
          StaffOpusID:row.ID ,
      }
      this.StaffOpusEdit=true;
    },
    toStaffOpusEdit(){
      var data = this.StaffOpusInfo
      const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var that = this
        this.ajax('editStaffOpus.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.getListStaffOpus()
              that.StaffOpusEdit=false;

              loading.close();

            }

        })
    }  ,  
    toStaffOpusshan(row){
      this.$confirm("确定删除作品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffOpusID:row.ID,
    
        }
        var that = this
        this.ajax('delStaffOpus.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.getListStaffOpus()
             
            }

        })
        })
        .catch(() => {
         
        });
    },
    toeditTtile(row){
        this.title1='编辑头衔'
        this.StaffTitleID = row.ID
        this.Pwd = row.Title
        this.passShow = true
    },
     addUnit(){
       this.title1='添加头衔'
       this.Pwd = ''
        this.passShow = true
    },
    toshow(){
      this.showUnit = true
    
    },
    getUnitList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
      var that = this
      this.ajax('getListStaffTitle.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.unitList = res.data
              
          } 
       })
    },
     tosetting(){
         this.$router.push({ path: '/setting/setting'})
      } ,
    changedian(){
      
       this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
      this.getType()
      this.getList()
    },
      getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

        })

    },
    toTop(row){
      var data = { SelectStoresID:this.SelectStoresID,        

          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
    
        }
        var that = this
        this.ajax('editStaffDesc.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
           
              that.getList()
             
            }

        })
 
    },
    toDown(row){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
    
        }
        var that = this
        this.ajax('editStaffAes.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getList()
             
            }

        })
    },
    toSort(){
         this.getListSort()
    },
    getListSort(){

    //  this.tableLoading = true
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:10000,
          StaffTypeID:0
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.tableSortData = res.data
                  that.sortSure = true
                 loading.close();
          } 

      })
  
  
    },
    chongzhi(row){
       this.$confirm("确定要重置吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
    
        }
        var that = this
        this.ajax('ResetStaffPwd.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "重置成功",duration:2000,
              });
              that.getList()
             
            }

        })
        })
        .catch(() => {
         
        });
    
    },
    toAll(){
      this.active = ''
      this.name = '全部'
      this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    toChoose(item){
        this.active = item.ID
        console.log(item.ID)
        this.name = item.StaffName
        this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
        this.getList()
    },
    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;  
      this.cropperModel = true;
    },
    handleUploadSuccess(data) {
            this.cropperModel = false
            if(this.cropperName == 'HeadUrl'){
              this.editForm.HeadUrl = data.url

              }else if(this.cropperName == 'ImgOpusUrl'){
                this.StaffOpusInfo.ImgOpusUrl = data.url
              }
 
  },
    subStaffName(){
    if(this.StaffName == ''){
             this.$message({
  
              duration:2000,
              message:'请输入部门名称'
            });
    }else {
              if(this.title == '添加部门'){
        var data = { SelectStoresID:this.SelectStoresID,        
                  token: localStorage.getItem("token"),
                  StoresID:localStorage.getItem("StoresID"),
                  StaffName:this.StaffName
              }
        var that = this
        this.ajax('addStaffType.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                that.$message({
              type: "success",
              duration:2000,
              message:'添加成功'
            });
            that.getType()
            that.getList()
            that.passShow2 = false
                  // that.tableLoading = false
                  // that.typeList = res.data
                  //  loading.close();
            } 
        })
    
      } else {
         var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          StaffName:this.StaffName,
          StaffTypeID:this.id
      }
      var that = this
      this.ajax('editStaffType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                duration:2000,
                message:'修改成功'
            });
            that.getType()
            that.getList()
            that.passShow = false
                // that.tableLoading = false
                // that.typeList = res.data
                //  loading.close();
          } 
       })
    
      }
    }

     
    },
    getType(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListStaffType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    },
    getList(){

    //  this.tableLoading = true
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
  
  
    },
    handlePassword(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑部门'
              this.id= row.ID
              this.StaffName = row.StaffName
          } else {
              this.title = '添加部门'
               this.id= ''
              this.StaffName =  ''
          }
 

      // this.editForm.ManageLoginID = row.ID
      // this.Pwd = ''
      this.passShow2 = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(row) {
       this.timer = new Date().getTime()
      if(this.typeList.length == 0 ){
            this.$message({
              // type: "success",
              message: "请先添加部门",
        });                           
      } else {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑' 
        var ed = row
        this.editForm = ed
        this.editForm.Sex = Number(row.Sex)
        this.editForm.ispk = Number(row.ispk)
        this.editForm.iszs = Number(row.iszs)

        
      } else {
        this.title = '添加'
        this.editForm = {
          Sex:1,
          HeadUrl:'',
          ispk:1,
          iszs:1,
          LoginName:"",
          Phone:"",
          Name:"",
          Pwd:'',

          StaffTypeID:'',
      }
        if(this.typeList.length == 1){

            this.editForm.StaffTypeID = this.typeList[0].ID
            
          }
      }
      
      }

    },
    // 编辑、增加页面保存方法
    submitForm(editData){

       this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            data.SelectStoresID = this.SelectStoresID  
              var that = this
              if(this.title == '添加'){
                  this.ajax('addStaff.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "新建成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                  that.getType()
                                }

                            })

                  }
              else if(this.title == '编辑'){
                      data.StaffID=  this.editForm.ID
                  this.ajax('editStaff.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                  that.getType()
                                }                                 

                    })         
                  
              }
              } 
        
       })
       
    },




handlejin(row){
 this.$confirm("确定要禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
          Isdisable:1
        }
        var that = this
        this.ajax('editStaffIsdisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "禁用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {

        });
   
},
handlejie(row){
 this.$confirm("确定要启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
          Isdisable:0
        }
        var that = this
        this.ajax('editStaffIsdisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "启用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   
},


    deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
        
        }
        var that = this
        this.ajax('delStaff.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
 
        });
   
    },
    toDel(row){
      
       this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffTypeID:row.ID,
        
        }
        var that = this
        this.ajax('delStaffType.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.sortSure = false
      this.passShow = false
      this.chongShow = false
      this.editFormVisible = false
    }
  }
}
</script>


<style>
  .el-popover{
    min-width:150px !important;
  }
</style>
<style scoped>
.timer{
    max-height: 50vh;
    overflow: auto;
  }
.css{
  border-bottom: 1px solid #e9e9e9;
}
.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #409EFF;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}
/* .shadow1 {
      border:1px solid #808080;border-radius:2px
} */

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.flexC{
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/personnel/personnel.vue